"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const administrators_json_1 = __importDefault(require("../../../auth-policies/json/administrators.json"));
const app_json_1 = __importDefault(require("../../../auth-policies/json/app.json"));
const broadcasters_json_1 = __importDefault(require("../../../auth-policies/json/broadcasters.json"));
const convenors_json_1 = __importDefault(require("../../../auth-policies/json/convenors.json"));
const directors_json_1 = __importDefault(require("../../../auth-policies/json/directors.json"));
const guest_json_1 = __importDefault(require("../../../auth-policies/json/guest.json"));
const managers_json_1 = __importDefault(require("../../../auth-policies/json/managers.json"));
const observers_json_1 = __importDefault(require("../../../auth-policies/json/observers.json"));
const registrar_json_1 = __importDefault(require("../../../auth-policies/json/registrar.json"));
const scheduler_json_1 = __importDefault(require("../../../auth-policies/json/scheduler.json"));
function parseYamlFile(file, policies) {
    const fileRole = Object.keys(file)[0];
    const levelKeys = Object.keys(file[fileRole]);
    const yamlPolicies = file[fileRole];
    for (const key of levelKeys) {
        const policy = yamlPolicies[key];
        const policyKey = key + fileRole;
        policies[policyKey] = policy;
    }
    return policies;
}
function getPolicies() {
    var policies = {};
    policies = parseYamlFile(administrators_json_1.default, policies);
    policies = parseYamlFile(app_json_1.default, policies);
    policies = parseYamlFile(broadcasters_json_1.default, policies);
    policies = parseYamlFile(convenors_json_1.default, policies);
    policies = parseYamlFile(directors_json_1.default, policies);
    policies = parseYamlFile(guest_json_1.default, policies);
    policies = parseYamlFile(managers_json_1.default, policies);
    policies = parseYamlFile(observers_json_1.default, policies);
    policies = parseYamlFile(registrar_json_1.default, policies);
    policies = parseYamlFile(scheduler_json_1.default, policies);
    return policies;
}
exports.default = getPolicies;
